// extracted by mini-css-extract-plugin
export default {"heading":"Todoform_heading__Hfd8+","input":"Todoform_input__h87zw","button":"Todoform_button__hKvBo"};